export * from './PageHero';

import { PageHero } from './PageHero';

export default PageHero;
